// extracted by css-extract-rspack-plugin
export default {"dimensionPicker":"DimensionsWidget-modules__dimensionPicker___zcYI9"};